export enum Roles {
    Admin = 'System Administrator',
    MultiTenantRO = 'Multi-Tenant Read Only',
    GlobalRoleManager = 'Global Role Manager',
    AppManager = 'Application Manager',
    UserManager = 'User Manager',
    ReportingAnalyst = 'Reporting Analyst',
    DataExporter = 'Data Exporter'
}

export const MULTI_TENANT_READ_ONLY_ROLES: Roles[] = [Roles.MultiTenantRO, Roles.ReportingAnalyst, Roles.DataExporter];

export enum TenantGlobalRoles {
    Administrator = 'Tenant Administrator',
    TenantRO = 'Tenant Read-Only',
    TenantACLManager = 'Tenant ACL Manager'
}
